import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'auth/ACTION_PROCESSING',
  GET_ACTIVE_LIMITS: 'auth/GET_ACTIVE_LIMITS',
  POST_ACTIVE_LIMITS: 'auth/POST_ACTIVE_LIMITS',
};

const getActiveLimits = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.agentAdmin.getBetsLimits();

  if (response.success) {
    dispatch({ type: actionTypes.GET_ACTIVE_LIMITS, payload: response.data });
  } else {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
  }
};

const postActiveLimits = (data) => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.agentAdmin.postBetsLimits(data);

  if (response.success) {
    dispatch({ type: actionTypes.POST_ACTIVE_LIMITS, payload: response.data });
  } else {
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
  }
};


export {
  actionTypes,
  getActiveLimits,
  postActiveLimits,
};
